import { Link, useLocation } from 'react-router-dom';
import Seo, { SITE_NAME } from '@/components/feature/Seo';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import { categories } from '@/mocks/categories';

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Seo
        title={`页面不存在 | ${SITE_NAME}`}
        description="这个页面可能已经调整位置或被整理进分类里了，回到首页或话题分类继续围观最热闹的玩梗现场吧。"
        keywords="糖心吃瓜,页面不存在,玩梗现场"
        path={location.pathname}
      />

      <Navbar />

      <main className="flex min-h-[80vh] items-center px-4 pb-16 pt-28 md:px-6">
        <div className="mx-auto w-full max-w-content">
          <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1.5 text-xs text-primary-700">
                <i className="ri-compass-3-line" aria-hidden="true" />
                404 · 走岔了
              </span>
              <h1 className="mt-4 text-3xl text-foreground-950 md:text-5xl">
                这个页面没被整理出来
              </h1>
              <p className="mt-4 max-w-lg text-sm leading-relaxed text-foreground-600 md:text-base">
                可能链接不太对，或者这条内容已经被归进了别的分类里。别急，从下面的入口继续逛，
                今天的热门现场都还在。
              </p>
              <p className="mt-3 text-xs text-foreground-400">
                当前地址：<span className="break-all font-mono">{location.pathname}</span>
              </p>
              <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
                <Link
                  to="/"
                  className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-home-4-line" aria-hidden="true" />
                  返回首页
                </Link>
                <Link
                  to="/topics"
                  className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  <i className="ri-fire-line" aria-hidden="true" />
                  去看今日热榜
                </Link>
              </div>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-6">
              <h2 className="text-lg text-foreground-950">或者直接从分类进去</h2>
              <div className="mt-4 grid gap-3 sm:grid-cols-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/topics?category=${cat.slug}`}
                    className="flex items-center gap-3 rounded-md border border-background-200 bg-background-50 px-3.5 py-3 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
                  >
                    <i className={`${cat.icon} text-lg text-primary-500`} aria-hidden="true" />
                    <span className="truncate">{cat.name}</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
      <BackToTop />
    </>
  );
}